import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionReceiptsOptions } from '../keys/permissionReceipts.enum';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionReceipts: PermissionOption[] = [
  {
    code: 'P334',
    option: PermissionReceiptsOptions.RECEIPTS_COMMON_LOGIN,
    permissions: ['receipts.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P335',
    option: PermissionReceiptsOptions.RECEIPTS_MANAGER_LIST,
    permissions: ['receipts.manage.list'],
  },
  {
    code: 'P430',
    option: PermissionReceiptsOptions.RECEIPTS_DASHBOARD_LIST,
    permissions: ['receipts.dashboard.list'],
  },
];
